export const PLAN_NAMES = ['Professional', 'Enterprise', 'Enterprise Plus'];

/**
 * 플랜별 기능 비교표.
 * 셀 값 규칙: true = 지원(●), false = 미지원(-), 문자열 = 그대로 표기.
 */
export const PLAN_ROWS = [
  { label: '기본 모듈', cells: ['Nova Investigator', 'Nova Investigator', 'Nova Investigator'] },
  { label: '연간 조사 대상', cells: ['100 Units', '300 Units', '1,000 Units'] },
  { label: '연간 분석 데이터 처리량', cells: ['10TB', '50TB', '200TB'] },
  { label: '등록 사용자', cells: ['10명', '30명', 'Unlimited'] },
  { label: '동시 조사자', cells: ['5', '15', '30'] },
  { label: 'PLAINBIT IoC/IoA DB', cells: [true, true, true] },
  { label: 'PLAINBIT 탐지 룰', cells: [true, true, true] },
  { label: '커스텀 탐지 룰', cells: [false, '20개/년', 'Unlimited'] },
  { label: 'AI 챗봇', cells: [true, true, true] },
  { label: '외부 서비스 연동', cells: [true, true, true] },
  { label: 'SIEM/SOAR 연동', cells: [false, true, true] },
  { label: 'REST API 제공', cells: [false, true, true] },
  { label: '교육', cells: ['연 1회(온라인)', '연 1회(방문)', '연 2회(방문)'] },
  { label: '기술지원', cells: ['영업시간 (09 ~ 18)', '우선지원 (12×5)', '전담 지원 (24×7)'] },
  { label: 'DFIR 서비스 할인', cells: ['10%', '15%', '20%'] },
  { label: '제품 로드맵 협의', cells: [false, false, true] },
];

/** Investigation Unit 모달 안의 플랜별 단가표 */
export const UNIT_ROWS = [
  { label: '가격', cells: ['Nova Investigator', 'Nova Investigator', 'Nova Investigator'] },
  {
    label: 'Investigation Units',
    cells: ['100 Units', '300 Units', '1,000 Units'],
    bold: true,
  },
  { label: 'Unit당 가격', cells: ['40만원', '약 26.7만원', '14만원'] },
  { label: '데이터', cells: ['10TB', '50TB', '200TB'] },
];

/** 1 Unit 으로 세는 조사 대상 */
export const UNIT_EXAMPLES = [
  'PC 1대 → 1 Unit',
  'Server 1대 → 1 Unit',
  'Disk Image 1개 → 1 Unit',
  'Cloud Account → 별도 Unit 정책',
  'M365 Mailbox → 별도 Unit 정책',
];

/** 초과 사용량 Unit Pack 가격 */
export const UNIT_PACKS = [
  { plan: 'Professional', amount: '+100 Units', price: '2,000만원' },
  { plan: 'Enterprise', amount: '+100 Units', price: '1,500만원' },
  { plan: 'Enterprise Plus', amount: '+100 Units', price: '1,000만원' },
];
